import { createMachine } from 'xstate';

export const loaderMachine = createMachine({
  id: 'loader',
  context: {},
  initial: 'ready',
  schema: {
    events: {} as
      | { type: 'RESET' }
      | { type: 'FINISH_SUCCESS' }
      | { type: 'FINISH_ERROR' }
      | { type: 'NEXT' },
  },
  predictableActionArguments: true,
  on: {
    RESET: 'ready',
    FINISH_SUCCESS: 'finishingSuccess',
    FINISH_ERROR: 'finishingError',
  },
  states: {
    ready: {
      tags: ['badge'],
      meta: {
        to: 227,
      },
      // Just skip thru "ready" state to start "loading".
      // We have to pass thru for 1ms in order to establish the start value (meta.to) for our transition animation
      after: {
        1: 'loading',
      },
    },
    loading: {
      initial: 'one',
      states: {
        one: {
          tags: ['mag'],
          meta: {
            messageIndex: 0,
          },
          on: {
            NEXT: 'takingLonger',
          },
        },
        takingLonger: {
          tags: ['gear'],
          meta: {
            messageIndex: 1,
          },
        },
      },
    },
    finishingError: {
      tags: ['gear', 'red'],
      meta: {
        to: 0,
        duration: '150ms',
      },
      on: {
        NEXT: 'finishedError',
      },
    },
    finishedError: {
      tags: ['x', 'red'],
      after: {
        DONE_AFTER: { actions: ['onDone'] },
      },
    },
    finishingSuccess: {
      tags: ['gear'],
      meta: {
        to: 0,
        duration: '150ms',
      },
      on: {
        NEXT: 'finishedSuccess',
      },
    },
    finishedSuccess: {
      tags: ['check'],
      after: {
        DONE_AFTER: { actions: ['onDone'] },
      },
    },
  },
});
